import { useQueryClient } from "@tanstack/react-query";
import appHomeEntryClient from "../../../api/appHomeEntry";
import useKlydoMutation from "../../../components/hooks/useKlydoMutation";

const useDeleteAppHomeEntryMutation = () => {
  const queryClient = useQueryClient();
  return useKlydoMutation({
    mutationKey: ["delete-app-home-entry"],
    mutationFn: (entryId: string) => {
      return appHomeEntryClient.deleteAppHomeEntry(entryId);
    },
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ["app-home-entries"],
      });
    },
  });
};
export default useDeleteAppHomeEntryMutation;
